import React, { ComponentProps } from 'react';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { useAppContext } from '../../contexts/AppContext/AppContext';
import { CommentsBlockInteractions } from './partials/CommentsBlockInteractions';
import { CommentsEditView } from './views/CommentsEditView';
import { DefaultView, OptionalEditView, Views } from '../../types/BlockWithViews';
import { CommentsDefaultView } from './views/CommentsDefaultView';

export type CommentsBlockProps = Views<DefaultView<CommentsDefaultView> & OptionalEditView<CommentsEditView>>;
function Comments({ views, activeView }: CommentsBlockProps) {
  const { editModeInfo } = useAppContext();
  const { active } = editModeInfo;
  switch (active) {
    case true:
      return <CommentsBlockInteractions views={views} activeView={activeView} />;
    default:
      return <CommentsDefaultView {...views.default} />;
  }
}

export const CommentsBlock = asFetchableBlock(Comments, BlockType.comments);
export type CommentsBlock = ComponentProps<typeof CommentsBlock>;
